<div class="main-wrapper">
  <section class="hero-section" [ngClass]="{'container-fluid': util.isMobile(), 'container': !util.isMobile()}">
    <div class="hero-section-wrapper">
      <div class="col1">
        <div class="title" [innerHTML]="info.title">
        </div>
        <div class="typing-animation">
          <app-module-loader
            [load]="util.isBrowser"
            moduleId="type-delete"
            selector="app-type-delete"
            [inputs]="{
              typingSpeedMilliseconds:'100', 
              deleteSpeedMilliseconds:'100',
              delay:'1200', 
              fontSize: util.isMobile() ? '28px': '48px',
              wordArray: info.wordArray,
              textBackgroundColor:'#3EA6A0',
              textColor:'#fff',
              blinkWidth:'3px'
            }"></app-module-loader>
        </div>
        <div class="sub-title">
          {{info.subTitle}}
        </div>
        <div class="plans-cta">
          <a (click)="onExplorePlanClicked()">
            <app-button [label]="'FIND MY PLAN'" btnClass="hf-primary-btn"></app-button>
          </a>
        </div>
      </div>
      <div class="col2">
        <div class="img-wrapper">
          <img src="/assets/images/health-first/health-hero-img.png" alt="health first image"/>
        </div>
      </div>
    </div>
    <div class="plan-details-wrapper slider-wrapper">
      <app-hf-plan-info [plans]="info?.plans" *ngIf="!dashboardLoading"></app-hf-plan-info>
    </div>
    <div class="banner-section" *ngIf="bannerImg">
      <img src="https://images.pexels.com/photos/5650026/pexels-photo-5650026.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1">
    </div>
    <div class="plan-benefits-wrapper" *ngIf="!util.isMobile()">
      <ng-container *ngTemplateOutlet="planBenefitsRef; context: { planBenefits: info.planBenefits }"></ng-container>
    </div>
  </section>
  <div class="plan-benefits-wrapper" *ngIf="util.isMobile()" [ngClass]="{'mobile': util.isMobile()}">
    <div class="swiper-container" [swiper]="config">
      <div class="swiper-wrapper">
        <ng-container *ngTemplateOutlet="planBenefitsRef; context: { planBenefits: info.planBenefits }"></ng-container>
      </div>
      <!-- <ngx-glide [showArrows]="false" [showBullets]="false" [gap]="20" [perView]="2" [perTouch]="1" [keyboard]="false"> -->
    <!-- </ngx-glide> -->
    </div>
  </div>
  <section class="why-hf-section">
    <div class="why-hf-header">
      <div class="why-hf-title">
        {{info.whyTitle}}
      </div>
      <div class="why-hf-sub-title">
        {{info.whySubTitle}}
      </div>
      <div class="why-hf-desc">
        <div class="text">
          {{info.whySmallDesc}}
        </div>
      </div>
    </div>
    <div class="content">
      <app-hf-benefit-detail #hfBenefitDetialRef [benefits]="info.benefits"></app-hf-benefit-detail>
    </div>
  </section>
  <section class="pitch-calculator">
    <div class="calculator-wrapper">
      <div class="col1">
        <div class="heading">
          <div class="title">
            {{info.calculatorInfo.title}}
          </div>
          <div class="sub-title">
            {{info.calculatorInfo.subTitle}}
          </div>
          <div class="desc">
            {{info.calculatorInfo.desc}}
          </div>
        </div>
      </div>
      <div class="col2">
        <div class="calculator">
          <div class="content">
            <div class="title" [innerHTML]="info?.calculator?.title"></div>
            <div class="amount" [innerHTML]="info?.calculator?.amount"></div>
            <div class="sub-title" [innerHTML]="info?.calculator?.subTitle"></div>
            <div class="desc" [innerHTML]="info?.calculator?.desc">
            </div>
          </div>
          <div class="btn-wrapper">
            <a routerLink="/healthfirst/calculator" (click)="calcClick()">
              <app-button btnClass="hf-secondary-btn" label="Calculate Now" ></app-button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="plans-section" [ngClass]="{'mobile mt-24': util.isMobile()}">
    <div class="header">
      <div class="title">
        {{info.planDetails.header.title}}
      </div>
      <div class="sub-title">
        {{info.planDetails.header.subTitle}}
      </div>
      <div class="desc">
        {{info.planDetails.header.desc}}
      </div>
    </div>
    <div class="plan-details">
      <app-hf-plan-details *ngIf="!util.isMobile()" [amountData]="planAmountData" [plans]="info?.planDetails?.plans" [recommended]="info?.recommended_plan"></app-hf-plan-details>
      <app-hf-plan-details-mob [amountData]="planAmountData" [showSlider]="true" *ngIf="util.isMobile()" [recommended]="info?.recommended_plan" [plans]="info?.plansMob"></app-hf-plan-details-mob>
    </div>
  </section>
  <app-hf-comments-section [info]="info"></app-hf-comments-section>
  <app-hf-contact-section [info]="info"></app-hf-contact-section>
</div>

<ng-template #planBenefitsRef let-planBenefits="planBenefits">
  <div class="plan-benefits-item swiper-slide" *ngFor="let item of planBenefits; index as i">
    <div class="content">
      <div class="title" [innerHTML]="item.title">
      </div>
      <div class="desc">
        {{item.about}}
      </div>
    </div>
    <div class="hr" *ngIf="i !== planBenefits.length - 1 && !util.isMobile()"></div>
  </div>
</ng-template>